import apiClient from './apiClient';
import { API_ROUTES } from './apiRoutes';

export const getSiteState = async (): Promise<{
  underMaintenance: boolean;
  passwordProtection: boolean;
}> => {
  try {
    const response = await apiClient.get(API_ROUTES.SITE_STATE);
    return response.data;
  } catch (error) {
    console.error('Error getting site state:', error);
    throw error;
  }
};

export const validateMaintenancePassword = async (
  password: string,
): Promise<boolean> => {
  try {
    await apiClient.post(API_ROUTES.SITE_STATE_VALIDATE, { password });
    return true;
  } catch (error) {
    console.error('Error validating maintenance password:', error);
    return false;
  }
};

export const registerUser = async (data: { email: string; username: string; password: string }) => {
  try {
    const response = await apiClient.post(API_ROUTES.REGISTER, data);
    return response.data;
  } catch (error) {
    console.error('Error registering user:', error);
    throw error;
  }
};

export const loginUser = async (data: { email: string; password: string }) => {
  try {
    const response = await apiClient.post(API_ROUTES.LOGIN, data);
    return response.data;
  } catch (error) {
    console.error('Error logging in user:', error);
    throw error;
  }
};

export const getGeneratorData = async () => {
  try {
    const response = await apiClient.get(API_ROUTES.GENERATOR);
    return response.data;
  } catch (error) {
    console.error('Error getting generator data:', error);
    throw error;
  }
};

export const generateRecipe = async (payload: any) => {
  try {
    const response = await apiClient.post(API_ROUTES.RECIPES.GENERATE, payload);
    return response.data;
  } catch (error) {
    console.error('Error generating recipe:', error);
    throw error;
  }
};

export const verifyEmail = async (token: string) => {
  try {
    const response = await apiClient.post(`${API_ROUTES.VERIFY_EMAIL}?token=${token}`);
    return response.data;
  } catch (error) {
    console.error('Error verifying email:', error);
    throw error;
  }
};
